module.exports = __webpack_public_path__ + "static/media/mpg-icon.14fea4d4.svg";